






































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'

@Component
export default class ComponentEmitirRelatorio extends Vue {
  loadEmitirRelatorio: boolean = false
  
  menuPrazo: boolean = false
  menuPrevisao: boolean = false

  textPrazo: string = ''
  textPrevisao: string = ''

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get showModal() { return this.getFinanceiroStore.modal.alterarDatas }
  set showModal(value: boolean) { this.getFinanceiroStore.setModal({ name: 'alterarDatas', value }) }

  get loadingEmitirRelatorio() { return this.loadEmitirRelatorio }
  set loadingEmitirRelatorio(value: boolean) { this.loadEmitirRelatorio = value }

  get dataPrazo() { return this.getFinanceiroStore.dataPrazo }
  set dataPrazo(value: string) { this.getFinanceiroStore.setDataPrazo(value) }

  get dataPrevisao() { return this.getFinanceiroStore.dataPrevisao }
  set dataPrevisao(value: string) { this.getFinanceiroStore.setDataPrevisao(value) }

  updatePrazo(date: string) {
    this.textPrazo = this.formatDate(date)
    this.menuPrazo = false
  }

  updatePrevisao(date: string) {
    this.textPrevisao = this.formatDate(date)
    this.menuPrevisao = false
  }

  formatDate(date: string) {
    if (!date) return ''
    const [year, month, day] = date.split('-')
    return `${day}-${month}-${year}`
  }

  async alterarDatas() {
    this.loadingEmitirRelatorio = true
    const id = this.getFinanceiroStore.idForLoadValidacaoEGeracaoRepasse
    
    const params = {
      geracaoRepasseId: this.getFinanceiroStore.idForLoadValidacaoEGeracaoRepasse,
      prazo: this.dataPrazo,
      dataRecebimento: this.dataPrevisao
    }
    const response = await this.getFinanceiroStore.alterarDatas(params) 
    
    if (response.success) {
      EventBus.$emit('setSnackbar', { 
        show: true, 
        text: 'Datas alteradas com sucesso!', 
        icon: 'done', 
        color: '#2E7D32' 
      })
      this.getFinanceiroStore.getGeracaoDeRepassesItemsVisualizar(id)
      this.showModal = false
    } else {
      EventBus.$emit('setSnackbar', { 
        show: true, 
        text: response.message || 'Erro ao alterar datas.', 
        icon: 'warning', 
        color: '#C62828' 
      })
    }
    this.loadingEmitirRelatorio = false
  }

  @Watch('showModal')
  onShowModalChange(val: boolean) {
    if (!val) {
      this.textPrazo = ''
      this.textPrevisao = ''
      this.dataPrazo = ''
      this.dataPrevisao = ''
    }
  }
}
